<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 19:43:41
 * @LastEditTime: 2019-09-02 18:45:36
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <div class="pageTitle">可查看下级经销商订单，如需对订单进行发货请登录经销商后台手机端。</div>

    <div class="btnBox">
      <el-button type="primary" @click="showLink=!showLink">手机端登陆地址</el-button>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="value.title"
        :name="'status-'+value.status"
        v-for="(value,key) in statusList"
        :key="key"
      ></el-tab-pane>
    </el-tabs>

    <el-form ref="form1" :model="form" label-width="120px" :inline="true">
      <!-- <time  /> -->
      <el-form-item label="下单时间:" style="text-align: center">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="form.start_time"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="结束时间"
            v-model="form.end_time"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="form.role">
          <el-option label="全部" value></el-option>

          <el-option label="订单号" value="0">订单号</el-option>
          <el-option label="产品编号" value="1">产品编号</el-option>
          <el-option label="产品名称" value="2">产品名称</el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.order_sn" clearable  v-if="form.role==0"></el-input>
        <el-input v-model="form.product_sn" clearable v-if="form.role==1"></el-input>
        <el-input v-model="form.product_name" clearable v-if="form.role==2"></el-input>
      </el-form-item>
      <el-form-item label="是否赠品:">
        <el-select v-model="form.isgift">
          <el-option label="全部" value></el-option>
          <el-option label="赠品" value="1"></el-option>
          <el-option label="非赠品" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经销商:">
        <el-col :span="12">
          <el-input v-model="form.to_sn" clearable></el-input>
        </el-col>
        <el-col :span="4" style="margin-left: 10px;">
          <el-button type="primary" @click="selectType()">选择</el-button>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch()">搜索</el-button>
        <el-button type="primary" @click="onExport()">导出</el-button>
      </el-form-item>
    </el-form>

    <div style="margin-bottom:10px">
      订单总额:
      <span style="color:red">￥{{parseFloat(all/100)}}</span>
    </div>
    <div
      class="tableBox"
      v-loading="loading"
      style="width: 100%;margin-bottom: 20px; overflow:auto"
    >
      <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px"
        border
        fit
        v-loading="loading"
        max-height="500"
      >
        <el-table-column prop="order_sn" label="订单号" fixed="left" width="180"></el-table-column>
        <el-table-column prop="from_sn" fixed="left" label="订货经销商编号" width="180"></el-table-column>

        <el-table-column prop="from_level_name" fixed="left" label="订货经销商级别" width="180"></el-table-column>
        <el-table-column prop label="订单金额" width="180">
          <template slot-scope="scope">{{parseFloat(scope.row.total_fee/100)}}</template>
        </el-table-column>
        <el-table-column prop="total_stock_out_num" label="支付方式">
          <template slot-scope="scope">
            <span v-if="scope.row.pay_type == 0">未支付</span>
            <span v-if="scope.row.pay_type == 1">线下支付</span>
            <span v-if="scope.row.pay_type == 2">微信支付</span>
          </template>
        </el-table-column>
        <el-table-column prop label="是否赠品" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.isgift == 1">赠品</span>
            <span v-else>非赠品</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="下单时间" width="180"></el-table-column>

        <el-table-column prop="order_notes" label="订单留言" width="180"></el-table-column>
        <el-table-column prop="product_sn" label="产品编号" width="180"></el-table-column>
        <el-table-column prop="product_name" label="产品名称" width="180"></el-table-column>
        <el-table-column prop="product_specs" label="产品规格" width="180"></el-table-column>
        <el-table-column prop fixed="right" label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">待发货</span>
            <span v-if="scope.row.status == 1">待收货</span>
            <span v-if="scope.row.status == 2">发货中</span>
            <span v-if="scope.row.status == 3">待付款</span>
            <span v-if="scope.row.status == 4">待审核</span>
            <span v-if="scope.row.status == 5">审核不通过</span>
            <span v-if="scope.row.status == 6">已完成</span>
            <span v-if="scope.row.status == 7">已取消</span>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              v-if="scope.row.status != 4 || scope.row.order_model!=1"
              @click="check(scope.row)"
            >查看详情</el-button>
            <el-button
              type="text"
              size="small"
              @click="del(scope.row)"
              v-if="scope.row.status==0 &&scope.row.order_model==1"
            >取消订单</el-button>
            <!-- <el-button type="text" size="small" @click="confirm(scope.row)" v-if="scope.row.status == 1">确认收货</el-button> -->
            <!-- <el-button type="text" size="small" @click="again(scope.row)" v-if="scope.row.status == 6||scope.row.status == 7">再次下单</el-button> -->
            <el-button
              type="text"
              size="small"
              @click="Review(scope.row)"
              v-if="scope.row.status== 4 &&scope.row.order_model==1"
            >审核订单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange1"
      @current-change="handleCurrentChange1"
      :current-page="pageNo1"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize1"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize1"
    ></el-pagination>

    <!--选择经销商-->
    <selectDealer
      v-if="selectDealerDialog"
      v-on:handleClose="selectDealerDialog = false"
      @pushData="getSelectinfo"
    ></selectDealer>
    <copyLinkDialog @handleClose="closeLink" v-if="showLink" />
  </div>
</template>


<script>
import selectDealer from "@/common/selectDealer";
import copyLinkDialog from "@/common/copyLinkDialog";
import handlerTable from "@/until/handlerTable.js";

export default {
  name: "myorder",
  data() {
    return {
      time: "下单时间",
      showLink: false,
      selectDealerDialog: false,
      loading: false,
      activeName: "status--1",
      form: {
        start_time: "",
        end_time: "",
        role: ""
      },
      tableData: [],
      //分页
      pageNo1: 1, //页码
      pageSize1: 20, //每页现实的条数
      totalSize1: 0, //总条数

      statusList: [],
      all: 0
    };
  },
  methods: {
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.pageNo1 = 1;
      //this.getDealerList();
      this.onSearch();
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      //this.getDealerList();
      this.onSearch();
    },
    getStatus() {
      this.$get("logistics_1", "/orders/status").then(res => {
        this.statusList = res.data;
        this.onSearch();
      });
    },
    onSearch() {
      this.loading = true;
      var status = this.activeName.replace("status-", "");
      this.$get("logistics_1", "/orders/subordinate/orders", {
        status: status,
        is_export: 0,
        channel: 1,
        ...this.form,
        to_type: 2
      }).then(res => {
  
        this.loading = false;
        this.all = res.sum_data.total_fee;
          this.totalSize1 = res.sum_data.count;
             this.tableData= handlerTable(res.data,{
            keys:"product"
        })
      });
    },
    Review(data) {
      this.$router.push({
        name: "next_review",
        query: {
          order_id: data.id
        }
      });
    },
    del(data) {
      this.$get("logistics_1", "/orders/cancel", {
        order_id: data.id
      })
        .then(res => {
          this.$message({
            type: "success",
            message: "取消订单成功"
          });
          this.onSearch();
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error.message
          });
        });
    },
    check(data) {
      this.$router.push({
        name: "next_detail",
        query: {
          order_id: data.id
        }
      });
    },
    onExport() {
      let url = "",
        access_tokens = localStorage.getItem("access_token");
      if (process.env.NODE_ENV == "development") {
        url = "http://logistics.c.";
      } else if (process.env.NODE_ENV == "production") {
        url = "http://logistics.";
      } else {
        url = "http://logistics.c.";
      }
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      var status = this.activeName.replace("status-", "");
      window.open(
        process.env.VUE_APP_URL_V1 +
          "/orders/subordinate/orders.export? " +
          "&lang=" +
          "" +
          "&is_export=1" +
          "&start_time=" +
          beginstr +
          "&end_time=" +
          endstr +
          "&product_name=" +
          this.form.product_name +
          "&product_sn=" +
          this.form.product_sn +
          "&order_sn=" +
          this.form.order_sn +
          "&status=" +
          status +
          "&channel=1" +
          +"&signature=" +
          this.$md5(access_tokens)
      );
    },
    //选择经销商
    selectType() {
      this.selectDealerDialog = true;
    },
    getSelectinfo(val) {
      if (val.dealer_sn) {
        this.form.to_sn = val.dealer_sn;
        this.form.to_type = 2;
      } else {
        this.form.to_sn = val.shop_sn;
        this.form.to_type = 3;
      }
    },
    closeLink() {
      //   关闭登陆地址弹窗
      this.showLink = !this.showLink;
    },
    handleClick() {
      this.onSearch();
    }
  },
  created() {
    this.getStatus();
  },
  components: {
    selectDealer,
    copyLinkDialog,
  }
};
</script>

